import { Component } from '@angular/core';

@Component({
  selector: 'app-about-comdica',
  templateUrl: './about-comdica.component.html',
  styleUrls: ['./about-comdica.component.sass']
})
export class AboutComdicaComponent {
  download() {
    let link = document.createElement("a");
    link.download = "plano_de_acoes_comdica_2024.docx";
    link.href = "assets/files/plano_de_acoes_comdica_2024.docx";
    link.click();
  }
}
